import { useLayoutEffect, useState } from "react";

// This custom hook returns current theme value and a theme toggler function
const useDarkMode = () => {
  const [theme, setTheme] = useState("default");

  // Getting theme value from local storage at startup
  useLayoutEffect(() => {
    const localTheme = window.localStorage.getItem("theme");
    localTheme && setTheme(localTheme);
  }, []);

  // Updating theme value with new parameter
  const themeUpdater = (theme) => {
    window.localStorage.setItem("theme", theme);
    setTheme(theme);
  };

  // Toggling theme value between default and dark
  const themeToggler = () => {
    theme === "default" ? themeUpdater("dark") : themeUpdater("default");
  };

  return [theme, themeToggler];
};

export default useDarkMode;
